module.exports = __webpack_public_path__ + "img/icon_educate@2x.ea2e9053.png";